import classNames from "classnames";
import * as React from "react";

interface IClientBarProps {
    mainHeader: string;
    showBack: boolean;
    onBackClick: () => void;
    subHeader?: string;
    isFz: boolean;
}
export class ActionMenuHeader extends React.Component<IClientBarProps, {}> {
    public render(): JSX.Element {
        if (!this.props.mainHeader) {return null;}
        return (
            <div
                className={classNames("cno-client-bar", {
                    "show-back": this.props.showBack,
                })}
            >
                <button
                    className="cno-return-button"
                    onClick={() => {
                        this.props.onBackClick();
                    }}
                >
                    <span className="icon" aria-hidden={true}></span>
                    <span className="lbl">
                        Back
                        <span className="sr-only">one menu level up</span>
                    </span>
                </button>
                <div className="cno-client-head">
                    <h1
                        className={classNames("cno-client-name", {
                            isFz: this.props.isFz,
                        })}
                    >
                        <span>{this.props.mainHeader}</span>
                    </h1>
                    <div className="cno-account-number">{this.props.subHeader ? this.props.subHeader : null}</div>
                </div>
            </div>
        );
    }
}
